export const FETCHING_RECORDS = "fetchingAccountingById";
export const APPEND_RECORD = "appendRecord";
